import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ChartControlBlock } from '../../menu-group/menu-group.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  FeatureStatus,
  PopulationService,
} from '../../population-menu/population.service';
import { UserAccessService } from '../../../../../../user/access/user-access.service';
import { NgClass, NgIf } from '@angular/common';
import { FeatureTooltipComponent } from '../feature-tooltip/feature-tooltip.component';
import { ChartYearSelectionComponent } from '../chart-year-selection/chart-year-selection.component';
import { PlotlyChartComponent } from '../plotly-chart/plotly-chart.component';
import { ChartWarningComponent } from '../chart-warning/chart-warning.component';
import {
  CustomSlideToggleComponent,
  SlideToggleChange,
} from '../../../../../../shared/components/custom-slide-toggle/custom-slide-toggle.component';
import { ModalService } from '../../../../../../shared/services/modal.service';
import { MapModalData } from '../../../../../../user/map-redirect-modal/map-redirect-modal.component';
import { CommuteAndMobilityService } from '../../commute-and-mobility/commute-and-mobility.service';

@Component({
  selector: 'app-chart-block',
  templateUrl: './chart-block.component.html',
  imports: [
    ReactiveFormsModule,
    NgClass,
    FeatureTooltipComponent,
    NgIf,
    ChartYearSelectionComponent,
    PlotlyChartComponent,
    ChartWarningComponent,
    CustomSlideToggleComponent,
  ],
  styleUrls: [
    './chart-block.component.scss',
    '../../../../../../app.component.scss',
  ],
})
export class ChartBlockComponent implements OnInit, OnChanges {
  @Output() changeSelectedYear = new EventEmitter<{
    year: number;
    usedFor: string;
  }>();

  @Input() chart!: ChartControlBlock;
  @Input() toggle!: FormControl;
  @Input() featureStatus!: FeatureStatus;
  @Input() disabled!: boolean;

  public readonly defaultChartStyle = { height: '430px', 'margin-top': '0px' };

  public wasYearSelected = true;

  constructor(
    private accessService: UserAccessService,
    private modalService: ModalService,
    private commuteAndMobilityService: CommuteAndMobilityService,
    private populationService: PopulationService
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled && this.toggle) {
      if (this.disabled) {
        this.toggle.disable({ emitEvent: false });
      } else {
        this.toggle.enable({ emitEvent: false });
      }
    }
  }

  public handleToggleChange(event: SlideToggleChange): void {
    if (event.checked) {
      if (!this.accessService.checkAccessIfUnauthorized()) {
        return;
      }
    }
  }

  public onSelectedYearChange(data: { year: number; usedFor: string }): void {
    const handlers: { [key: string]: (year: number) => void } = {
      householdsByVehiclesYear: (year: number) =>
        this.commuteAndMobilityService.updateHouseholdsByVehiclesChartByYear(
          year
        ),
      maritalStatusYear: (year: number) =>
        this.populationService.updateMaritalStatusChartByYear(year),
      workCommuteModesYear: (year: number) =>
        this.commuteAndMobilityService.updateWorkCommuteModesChartByYear(year),
      travelTimeToWorkYear: (year: number) =>
        this.commuteAndMobilityService.updateTravelTimeToWorkChartByYear(year),
      timeOfDepartureToWorkYear: (year: number) =>
        this.commuteAndMobilityService.updateTimeOfDepartureToWorkChartByYear(
          year
        ),
    };

    const handler = handlers[data.usedFor];

    if (handler) {
      handler(data.year);
    } else {
      this.changeSelectedYear.emit(data);
    }
  }

  public handleTooltipModalOpen(modalData: MapModalData): void {
    this.modalService.openModal(modalData);
  }
}
